import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// MANTINE IMPORTS
import {
  createTheme as createMantineTheme,
  Loader,
  MantineProvider,
} from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";

import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import Plans from "./Pages/Plans";
import SinglePlan from "./Pages/SinglePlan";

import PendingSubscriptions from "./Pages/PendingSubscriptions";
import Subscriptions from "./Pages/Subscriptions";
import TransactionsPage from "./Pages/Transactions";

import Overview from "./Pages/Overview";
import SupportTickets from "./Pages/SupportTickets";
import Team from "./Pages/Team";
import UsersPage from "./Pages/Users";
import "./styles/index.scss";
import SingleSubscriptionPage from "./Pages/SingleSubscription";
import PromotersPage from "./Pages/Promoters";
import SinglePromoter from "./Pages/SinglePromoter";
import SingleUser from "./Pages/SingleUser";
import OfflinePaymentsPage from "./Pages/OfflinePayments";
const mantineTheme = createMantineTheme({
  components: {
    Loader: Loader.extend({
      defaultProps: {
        type: "bars",
      },
    }),
  },
});
console.log(process.env.REACT_APP_BASE_URL);
function RedirectWhereNecessary() {
  useEffect(() => {
    const token = localStorage.getItem("t");
    if (!token) {
      window.location.href = "/login";
    } else {
      window.location.href = "/dashboard";
    }
  }, []);
  return <></>;
}
const router = createBrowserRouter([
  {
    path: "/",
    element: <RedirectWhereNecessary />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    children: [
      { index: true, path: "/dashboard", element: <Overview /> },
      { path: "/dashboard/plans", element: <Plans /> },
      { path: "/dashboard/plan/:planID", element: <SinglePlan /> },
      { path: "/dashboard/transactions", element: <TransactionsPage /> },
      { path: "/dashboard/subscriptions", element: <Subscriptions /> },
      {
        path: "/dashboard/subscription/:subscriptionID",
        element: <SingleSubscriptionPage />,
      },
      { path: "/dashboard/temps", element: <PendingSubscriptions /> },
      { path: "/dashboard/users", element: <UsersPage /> },
      { path: "/dashboard/user/:userID", element: <SingleUser /> },
      { path: "/dashboard/promoters", element: <PromotersPage /> },
      { path: "/dashboard/promoter/:userID", element: <SinglePromoter /> },
      { path: "/dashboard/team", element: <Team /> },
      { path: "/dashboard/support", element: <SupportTickets /> },
      { path: "/dashboard/offline-payments", element: <OfflinePaymentsPage /> },
    ],
  },
]);

export default function App() {
  return (
    <MantineProvider theme={mantineTheme}>
      <Notifications position="bottom-right" />
      <RouterProvider router={router} />
    </MantineProvider>
  );
}
